"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPikkuJuttuSmall = function IconPikkuJuttuSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m6.978 2 .638.433c1.757 1.194 3.142 2.65 4.144 4.365l.209.371-1.76.952Q9.107 6.08 7.165 4.575l-.04-.031-.2.19c-1.89 1.816-2.842 3.47-2.918 4.948L4 9.874c-.023 1.746.843 3.228 2.692 4.479.2-1.325.811-2.6 1.832-3.62q2.539-2.54 13.433-4.241l-.157.973q-1.66 10.035-4.084 12.46a6.502 6.502 0 0 1-10.946-3.196C3.604 15.025 1.963 12.714 2 9.86c0-2.31 1.396-4.663 4.101-7.094l.295-.26zm12.533 6.937-.308.06c-5.04.96-8.184 2.07-9.264 3.15a4.504 4.504 0 0 0-.696 5.471c.894-2.157 2.285-3.871 4.164-5.122l.298-.191 1.058 1.697c-1.895 1.18-3.214 2.895-3.971 5.18a4.5 4.5 0 0 0 5.511-.672c1.08-1.08 2.19-4.223 3.15-9.263z"
  })));
};

export { IconPikkuJuttuSmall, IconPikkuJuttuSmall as default };
